import api from './api'

export const companyProfileFields = ['legalName', 'tradingName', 'website', 'address', 'city', 'region', 'country', 'postalCode', 'telephone', 'industry', 'registrationIdentifier', 'latitude', 'longitude', 'timezone', 'logoUrl'] as const
export type CompanyField = typeof companyProfileFields[number]
export type CompanyFields = Partial<Record<CompanyField, string | number>>
export type CompanyProfileConfirmation = { expectedRevision: number; fields: CompanyFields; lookupKey?: string; matchId?: string }
export type CompanyMatch = {
  id: string; fields: CompanyFields; providerId: string; sourceUrl: string; confidence: number | null
  retrievedAt: string; expiresAt: string; attribution: string; termsReference: string; verificationStatus: 'unverified'
}
export async function getCompanyEnrichmentStatus() {
  return (await api.get<{ enabled: boolean; configured: boolean; providers: { id: string; attribution: string }[] }>('/api/onboarding/company-enrichment')).data
}
export async function searchCompanies(query: string, providerId: string) {
  return (await api.post<{ lookupKey: string; matches: CompanyMatch[] }>('/api/onboarding/company-enrichment/search', { query, providerId })).data
}
export type OrganizationEnrichment = {
  state: 'pending' | 'processing' | 'completed' | 'partial' | 'failed' | 'skipped'
  reasonCode?: string; lookupKey?: string; matches?: CompanyMatch[]
}
export async function changeOrganizationEnrichment(orgId: string, action: 'retry' | 'skip') {
  return (await api.post<{ enrichment: OrganizationEnrichment }>(`/api/orgs/${orgId}/business-profile/enrichment`, { action })).data
}
export async function getCompanyBusinessProfile(orgId: string) {
  return (await api.get<{ business_profile: Partial<Record<CompanyField, { value: string | number }>>; business_profile_revision: number; enrichment?: OrganizationEnrichment | null; preparation?:{suggestedIndustryKey?:string;proposedLocations?:Array<{name:string;address?:string}>}|null }>(`/api/orgs/${orgId}/business-profile`)).data
}
export async function saveCompanyBusinessProfile(orgId: string, payload: { expectedRevision: number; fields: CompanyFields; lookupKey?: string; matchId?: string }) {
  return (await api.patch(`/api/orgs/${orgId}/business-profile`, payload)).data
}
